import { Routes } from '@angular/router';
import { ApplicationCardsComponent } from './pages/application-cards/application-cards.component';
import { EditBeneficiaryComponent } from './pages/edit-beneficiary/edit-beneficiary.component';
import { beneficiaryResolver } from './pages/edit-beneficiary/beneficiaryResolver';
import { UserApi } from './shared/services/api/user.api';
import { applicationMainPageResolver } from './pages/application-cards/applicationMainPageResolver';
import { OrganizationCreateInfoComponent } from './pages/organization-create-info/organization-create-info.component';
import { familyMemberResolver } from './pages/family-member/familyMemberResolver';
import { FamilyMemberComponent } from './pages/family-member/family-member.component';
import { APP_PATHS } from './core/config/app-paths';
import { MainAppLayoutComponent } from './core/components/main-app-layout/main-app-layout.component';
import { MainAuthLayoutComponent } from './core/components/main-auth-layout/main-auth-layout.component';
import { LoginMethodComponent } from './pages/auth-context/login-method/login-method.component';
import { ApplicationContextComponent } from './pages/auth-context/application-context/application-context.component';
import { OrganizationSettingsComponent } from './pages/organization-settings/organization-settings.component';
import { InboxComponent } from './pages/inbox/inbox.component';
import { ApplicationSentComponent } from './pages/application-sent/application-sent.component';
import { BeneficiarySettingsComponent } from './pages/beneficiary-settings/beneficiary-settings.component';
import { AuthElectronicSignature } from './pages/auth-context/auth-electronic-signature/auth-electronic-signature';
import { AuthDevelopers } from './pages/auth-context/auth-developers/auth-developers';
import { userSettingsPageResolver } from './pages/beneficiary-settings/user-settings-page.resolver';
import { AuthGuard } from './core/guards/auth-guard';
import { applicationContextResolver } from './pages/auth-context/application-context/application-context.resolver';
import { DokumentApi } from './shared/services/api/dokument.api';
import { homePageUrlResolver } from './shared/resolvers/homepage-url.resolver';
import { JoinOrganizationComponent } from './pages/organization-invite/join-organization/join-organization.component';
import { EmailVerifiedGuard } from './core/guards/email-verified-guard';
import { FirstLoginComponent } from './pages/first-login/first-login.component';
import { BeneficiaryVerify } from './pages/beneficiary-verify/beneficiary-verify';
import { TermsAndConditionsComponent } from './pages/terms-and-conditions/terms-and-conditions.component';
import { termsAndConditionsResolver } from './pages/terms-and-conditions/termsAndConditionsResolver';
import { TermsAndConditionsBlockGuard } from './core/guards/terms-and-conditions-block-guard';
import { TermsAndConditionsGuard } from './core/guards/terms-and-conditions-guard';
import { environment } from './environments/environment';
import { firstLoginResolver } from './pages/first-login/firstLoginResolver';
import { DataVerifiedGuard } from './core/guards/data-verified-guard';
import { MainAdminLayoutComponent } from './core/components/main-admin-layout/main-admin-layout.component';
import { AdminPanelRules } from './pages/admin-panel/admin-panel-rules/admin-panel-rules';
import { AdminPanelReports } from './pages/admin-panel/admin-panel-reports/admin-panel-reports';
import { AdminPanelReportsGenerateComponent } from './pages/admin-panel/admin-panel-reports/components/admin-panel-reports-generate/admin-panel-reports-generate.component';
import { AdminPanelAnnouncementPreview } from './pages/admin-panel/admin-panel-announcements/pages/announcement-preview/admin-panel-announcement-preview';
import { AdminPanelAnnouncements } from './pages/admin-panel/admin-panel-announcements/admin-panel-announcements';
import { RuleAddComponent } from './pages/admin-panel/admin-panel-rules/pages/rule-add/rule-add';
import { announcementDetailsResolver } from './pages/admin-panel/admin-panel-announcements/resolvers/announcement-details.resolver';
import { LoginAuthGuard } from './core/guards/login-auth-guard';
import { appVersionResolver } from './shared/resolvers/app-version.resolver';
import { ruleDetailsResolver } from './pages/admin-panel/admin-panel-rules/resolvers/rule-details.resolver';
import { AdminPanelRuleDetails } from './pages/admin-panel/admin-panel-rules/pages/admin-panel-rule-details/admin-panel-rule-details';
import { AdminPanelAnnouncementEdit } from './pages/admin-panel/admin-panel-announcements/pages/announcement-edit/admin-panel-announcement-edit';
import { announcementEditResolver } from './pages/admin-panel/admin-panel-announcements/resolvers/announcement-edit.resolver';
import { AdminPanelAnnouncementAdd } from './pages/admin-panel/admin-panel-announcements/pages/announcement-add/admin-panel-announcement-add';
import { AdminPanelApplications } from './pages/admin-panel/admin-panel-applications/admin-panel-applications';
import { AdminPanelApplicationPreview } from './pages/admin-panel/admin-panel-applications/pages/application-preview/admin-panel-application-preview';
import { AdminRouteIdGuard } from './core/guards/admin-route-id.guard';
import { AdminPanelUsersNavigationContextGuard } from './core/guards/admin-panel-users-navigation-context.guard';
import { AdminPanelRuleEdit } from './pages/admin-panel/admin-panel-rules/pages/admin-panel-rule-edit/admin-panel-rule-edit';
import { ruleEditResolver } from './pages/admin-panel/admin-panel-rules/pages/resolvers/rule-edit.resolver';
import { AdminPanelApplicationFormEdit } from './pages/admin-panel/admin-panel-applications/pages/application-form-edit/admin-panel-application-form-edit';
import { applicationFormDetailsResolver } from './pages/admin-panel/admin-panel-applications/resolvers/application-form-details.resolver';
import { AdminPanelUsers } from './pages/admin-panel/admin-panel-users/admin-panel-users';
import { AdminPanelUserPreview } from './pages/admin-panel/admin-panel-users/pages/user-preview/admin-panel-user-preview';
import { AdminUserPreviewStateGuard } from './pages/admin-panel/admin-panel-users/guards/admin-user-preview-state.guard';
import { AdminPanelUserPreviewStateService } from './pages/admin-panel/admin-panel-users/state/admin-panel-user-preview-state.service';
import { AdminPanelUsersApi } from './shared/services/api/admin-panel-users.api';
import { applicationTypesResolver } from './pages/admin-panel/admin-panel-reports/resolvers/report-types.resolver';
import { AuthAdminGuard } from './core/guards/auth-admin-guard';
import { AdminPanelHome } from './pages/admin-panel/admin-panel-home/admin-panel-home';
import { AdminPanelUserOrganizationPreview } from './pages/admin-panel/admin-panel-users/pages/user-preview/components/user-organization-details/admin-panel-user-organization-preview/admin-panel-user-organization-preview';
import { AdminPanelUsersNavigationContextMode } from './shared/enums/admin-panel-users-navigation-context-mode.enum';

export const AppRoutes = [
  {
    path: '',
    title: 'Strona dla zalogowanych użytkowników',
    component: MainAppLayoutComponent,
    data: { sitemap: true },
    canMatch: [AuthGuard],
    providers: [UserApi],
    resolve: {
      homePageUrl: homePageUrlResolver,
    },
    children: [
      {
        path: APP_PATHS.home,
        title: 'Strona główna',
        component: ApplicationCardsComponent,
        data: { breadcrumb: 'Strona główna', sitemap: true },
        providers: [DokumentApi],
        resolve: {
          applications: applicationMainPageResolver,
          beneficiary: beneficiaryResolver,
        },
        canActivate: [TermsAndConditionsGuard, DataVerifiedGuard],
      },
      {
        path: APP_PATHS.userSettings.root,
        data: {
          breadcrumb: 'Ustawienia',
          sitemap: true,
          onlyForBeneficjent: true,
        },
        providers: [UserApi],
        canActivate: [TermsAndConditionsGuard],
        children: [
          {
            path: '',
            component: BeneficiarySettingsComponent,
            data: { breadcrumb: null },
            resolve: {
              beneficiary: beneficiaryResolver,
            },
            canActivate: [DataVerifiedGuard],
          },
          {
            path: APP_PATHS.userSettings.withPage,
            component: BeneficiarySettingsComponent,
            data: { breadcrumb: 'Panel użytkownika' },
            resolve: {
              beneficiary: beneficiaryResolver,
              page: userSettingsPageResolver,
            },
            canActivate: [DataVerifiedGuard],
          },
          {
            path: APP_PATHS.userSettings.editUser,
            component: EditBeneficiaryComponent,
            data: { breadcrumb: 'Zmiana danych' },
            resolve: {
              user: beneficiaryResolver,
            },
          },
          {
            path: APP_PATHS.userSettings.editFamilyMember,
            component: FamilyMemberComponent,
            data: {
              breadcrumb: 'Członek rodziny',
            },
            resolve: {
              familyMember: familyMemberResolver,
            },
            canActivate: [DataVerifiedGuard],
          },
          {
            path: APP_PATHS.userSettings.addFamilyMember,
            component: FamilyMemberComponent,
            data: { breadcrumb: 'Członek rodziny' },
            canActivate: [DataVerifiedGuard],
          },
        ],
      },
      {
        path: APP_PATHS.post.root,
        canActivate: [
          TermsAndConditionsGuard,
          EmailVerifiedGuard,
          DataVerifiedGuard,
        ],
        title: 'Skrzynka',
        data: {
          breadcrumb: null,
          sitemap: true,
          ignoreSitemapRedirect: true,
        },
        children: [
          {
            path: APP_PATHS.post.inbox,
            component: InboxComponent,
            data: { breadcrumb: 'Skrzynka odbiorcza', sitemap: true },
            title: 'Skrzynka odbiorcza',
          },
          {
            path: APP_PATHS.post.sent,
            component: ApplicationSentComponent,
            data: { breadcrumb: 'Wnioski wysłane', sitemap: true },
            title: 'Wnioski wysłane',
          },
        ],
      },
      {
        path: APP_PATHS.organization.root,
        data: {
          breadcrumb: 'Dane organizacji',
          sitemap: true,
          onlyForOrganization: true,
        },
        canActivate: [
          TermsAndConditionsGuard,
          EmailVerifiedGuard,
          DataVerifiedGuard,
        ],
        children: [
          {
            path: '',
            component: OrganizationSettingsComponent,
            data: { breadcrumb: null },
          },
        ],
      },
      {
        path: APP_PATHS.createOrganization,
        component: OrganizationCreateInfoComponent,
        data: {
          breadcrumb: 'Utwórz organizację',
          sitemap: true,
          onlyForBeneficjent: true,
        },
        canActivate: [
          TermsAndConditionsGuard,
          EmailVerifiedGuard,
          DataVerifiedGuard,
        ],
      },
      {
        path: APP_PATHS.termsAndConditions,
        component: TermsAndConditionsComponent,
        data: { breadcrumb: 'Regulamin', sitemap: false },
        resolve: {
          termsAndConditions: termsAndConditionsResolver,
        },
        canActivate: [TermsAndConditionsBlockGuard],
      },
    ],
  },
];

export const LoginRoutes = [
  {
    path: 'auth',
    title: 'Strona logowania',
    component: MainAuthLayoutComponent,
    data: { sitemap: true, ignoreSitemapRedirect: true },
    resolve: {
      homePageUrl: homePageUrlResolver,
    },
    children: [
      {
        path: APP_PATHS.auth.loginMethod,
        title: 'Metody logowania',
        component: LoginMethodComponent,
        data: { sitemap: true, ignoreSitemapRedirect: true },
        resolve: {
          localStorageCleanup: appVersionResolver,
        },
        canActivate: [LoginAuthGuard],
      },
      ...(environment.QUALIFIED_SIGNATRE_AUTH_VISIBLE
        ? [
            {
              path: APP_PATHS.auth.authElectronicSignature,
              title: 'Logowanie podpisem elektronicznym',
              component: AuthElectronicSignature,
              data: { sitemap: true, ignoreSitemapRedirect: true },
            },
          ]
        : []),
      {
        path: APP_PATHS.auth.firstLogin,
        component: FirstLoginComponent,
        resolve: {
          beneficiary: firstLoginResolver,
        },
        providers: [UserApi],
        data: {
          breadcrumb: 'Formularz rejestracji nowego konta',
        },
      },
      {
        path: APP_PATHS.auth.verify,
        component: BeneficiaryVerify,
        providers: [UserApi],
        data: {
          breadcrumb: 'Weryfikacja adresu email użytkownika',
        },
      },
      {
        path: APP_PATHS.auth.applicationContext,
        title: 'Wybór kontekstu / konta',
        canMatch: [AuthGuard],
        resolve: {
          beneficjent: applicationContextResolver,
        },
        component: ApplicationContextComponent,
        data: {},
      },
      ...(!environment.production
        ? [
            {
              path: APP_PATHS.auth.authDevelopers,
              component: AuthDevelopers,
            },
          ]
        : []),
    ],
  },
];

export const APP_ROUTES = {
  POST_INBOX: `/${APP_PATHS.post.root}/${APP_PATHS.post.inbox}`,
} as const;

export const JoinOrganizationRoutes = [
  { path: 'ewnioski/organizacja/join', component: JoinOrganizationComponent },
];

export const AdminRoutes = [
  {
    path: APP_PATHS.admin.root,
    title: 'Strona przeznaczona dla administratora',
    canMatch: [AuthAdminGuard],
    component: MainAdminLayoutComponent,
    data: { sitemap: true, ignoreSitemapRedirect: true, onlyForAdmin: true },
    children: [
      {
        path: '',
        title: 'Strona główna panelu administratora',
        component: AdminPanelHome,
        data: { breadcrumb: 'Strona główna', sitemap: true },
      },
      {
        path: APP_PATHS.admin.applications,
        data: {
          sitemap: true,
          ignoreSitemapRedirect: true,
          breadcrumb: 'Zarządzanie wnioskami',
        },
        children: [
          {
            path: '',
            title: 'Zarządzanie wnioskami',
            component: AdminPanelApplications,
            data: {
              breadcrumb: null,
              sitemap: true,
              ignoreSitemapRedirect: true,
            },
          },
          {
            path: APP_PATHS.admin.idDetails,
            title: 'Szczegóły wniosku',
            component: AdminPanelApplicationPreview,
            data: {
              sitemap: true,
              ignoreSitemapRedirect: true,
              breadcrumb: 'Szczegóły wniosku',
              invalidIdRedirect: `/${APP_PATHS.admin.root}/${APP_PATHS.admin.applications}`,
            },
            canActivate: [AdminRouteIdGuard],
            resolve: {
              applicationForm: applicationFormDetailsResolver,
            },
          },
          {
            path: APP_PATHS.admin.idEdit,
            title: 'Edycja wniosku',
            component: AdminPanelApplicationFormEdit,
            data: {
              sitemap: true,
              ignoreSitemapRedirect: true,
              breadcrumb: 'Edycja wniosku',
            },
            resolve: {
              application: applicationFormDetailsResolver,
            },
          },
        ],
      },
      {
        path: APP_PATHS.admin.users,
        providers: [AdminPanelUserPreviewStateService],
        data: {
          sitemap: true,
          ignoreSitemapRedirect: true,
          breadcrumb: 'Zarządzanie użytkownikami',
        },
        children: [
          {
            path: '',
            title: 'Zarządzanie użytkownikami',
            component: AdminPanelUsers,
            data: {
              breadcrumb: null,
              sitemap: true,
              ignoreSitemapRedirect: true,
            },
          },
          {
            path: APP_PATHS.admin.details,
            title: 'Szczegóły użytkownika',
            component: AdminPanelUserPreview,
            providers: [AdminPanelUsersApi],
            data: {
              sitemap: true,
              ignoreSitemapRedirect: true,
              breadcrumb: 'Szczegóły użytkownika',
              contextMode: AdminPanelUsersNavigationContextMode.UserDetails,
            },
            canActivate: [AdminUserPreviewStateGuard],
          },
          {
            path: APP_PATHS.admin.userOrganizationDetailsPage,
            title: 'Dane organizacji',
            component: AdminPanelUserOrganizationPreview,
            providers: [AdminPanelUsersApi],
            data: {
              sitemap: true,
              ignoreSitemapRedirect: true,
              breadcrumb: 'Dane organizacji',
              contextMode:
                AdminPanelUsersNavigationContextMode.OrganizationDetails,
            },
            canActivate: [AdminPanelUsersNavigationContextGuard],
          },
        ],
      },
      {
        path: APP_PATHS.admin.announcements,
        data: {
          sitemap: true,
          ignoreSitemapRedirect: true,
          breadcrumb: 'Zarządzanie komunikatami',
        },
        children: [
          {
            path: '',
            title: 'Zarządzanie komunikatami',
            component: AdminPanelAnnouncements,
            data: {
              sitemap: true,
              ignoreSitemapRedirect: true,
              breadcrumb: null,
            },
          },
          {
            path: APP_PATHS.admin.idDetails,
            title: 'Szczegóły komunikatu',
            component: AdminPanelAnnouncementPreview,
            data: {
              sitemap: true,
              ignoreSitemapRedirect: true,
              breadcrumb: 'Szczegóły komunikatu',
              invalidIdRedirect: `/${APP_PATHS.admin.root}/${APP_PATHS.admin.announcements}`,
            },
            canActivate: [AdminRouteIdGuard],
            resolve: {
              announcement: announcementDetailsResolver,
            },
          },
          {
            path: APP_PATHS.admin.idEdit,
            title: 'Edycja komunikatu',
            component: AdminPanelAnnouncementEdit,
            data: {
              sitemap: true,
              ignoreSitemapRedirect: true,
              breadcrumb: 'Edycja komunikatu',
              invalidIdRedirect: `/${APP_PATHS.admin.root}/${APP_PATHS.admin.announcements}`,
            },
            canActivate: [AdminRouteIdGuard],
            resolve: {
              announcement: announcementEditResolver,
            },
          },
          {
            path: APP_PATHS.admin.add,
            title: 'Dodawanie komunikatu',
            component: AdminPanelAnnouncementAdd,
            data: {
              sitemap: true,
              ignoreSitemapRedirect: true,
              breadcrumb: 'Dodawanie komunikatu',
            },
          },
        ],
      },
      {
        path: APP_PATHS.admin.rules,
        title: 'Zarządzanie regulaminem',
        data: {
          sitemap: true,
          ignoreSitemapRedirect: true,
          breadcrumb: 'Zarządzanie regulaminem',
        },
        children: [
          {
            path: '',
            title: 'Zarządzanie regulaminem',
            component: AdminPanelRules,
            data: {
              sitemap: true,
              ignoreSitemapRedirect: true,
              breadcrumb: '',
            },
          },
          {
            path: APP_PATHS.admin.idDetails,
            title: 'Szczegóły Regulaminu',
            component: AdminPanelRuleDetails,
            data: {
              sitemap: true,
              ignoreSitemapRedirect: true,
              breadcrumb: 'Szczegóły Regulaminu',
            },
            resolve: {
              rule: ruleDetailsResolver,
            },
          },
          {
            path: APP_PATHS.admin.idEdit,
            title: 'Edycja regulaminu',
            component: AdminPanelRuleEdit,
            data: {
              sitemap: true,
              ignoreSitemapRedirect: true,
              breadcrumb: 'Edycja regulaminu',
              invalidIdRedirect: `/${APP_PATHS.admin.root}/${APP_PATHS.admin.rules}`,
            },
            canActivate: [AdminRouteIdGuard],
            resolve: {
              rule: ruleEditResolver,
            },
          },
          {
            path: APP_PATHS.admin.add,
            component: RuleAddComponent,
            data: { breadcrumb: 'Dodawanie nowej wersji regulaminu' },
          },
        ],
      },
      {
        path: APP_PATHS.admin.reports,
        data: {
          sitemap: true,
          ignoreSitemapRedirect: true,
          breadcrumb: 'Raporty',
        },
        resolve: {
          applicationTypes: applicationTypesResolver,
        },
        children: [
          {
            path: '',
            title: 'Raporty',
            component: AdminPanelReports,
            data: {
              sitemap: true,
              ignoreSitemapRedirect: true,
              breadcrumb: null,
            },
          },
          {
            path: APP_PATHS.admin.generate,
            title: 'Generowanie raportu',
            component: AdminPanelReportsGenerateComponent,
            data: {
              sitemap: true,
              ignoreSitemapRedirect: true,
              breadcrumb: 'Generowanie raportu',
            },
          },
        ],
      },
    ],
  },
];

export const routes: Routes = [
  ...JoinOrganizationRoutes,
  ...AdminRoutes,
  ...LoginRoutes,
  ...AppRoutes,
];
